import React from "react";
import { OrderConfirmation } from "~/components/OrderConfirmation/OrderConfirmation";

export const SingleOrder = () => {
  return  <OrderConfirmation backButton={false} />
}